import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=84c9f598&scoped=true&"
import script from "./forget-pwd.vue?vue&type=script&lang=ts&"
export * from "./forget-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=84c9f598&prod&lang=scss&scoped=true&"
import style1 from "./forget-pwd.vue?vue&type=style&index=1&id=84c9f598&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9f598",
  null
  
)

export default component.exports